import {TOGGLE_MODAL} from './actions.js';

export function toggleModal(key, modalState) {
  return {
    type: TOGGLE_MODAL,
    key: key,
    value: modalState,
  };
}
